import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const meSettingsSchema = z.object({
  density: z.enum(["comfortable", "compact"]),
  theme: z.enum(["system", "light", "dark"]),
  sidebarCollapsed: z.boolean(),
});

export const patchMeSettingsSchema = meSettingsSchema
  .partial()
  .refine((settings) => Object.keys(settings).length > 0, "At least one setting must be provided.");

export const meSettingsResponseSchema = z.object({
  settings: meSettingsSchema,
});

export class PatchMeSettingsDto extends createZodDto(patchMeSettingsSchema) {}

export class MeSettingsResponseDto extends createZodDto(meSettingsResponseSchema) {}
